import * as Yup from 'yup';
import { keys } from 'lodash';
import moment from 'moment';

import { BOD_RULES, validationSchema } from 'utils/validations';
import { FORM_FIELDS, initialValue } from './constant';

export const informationValidation = Yup.object().shape({
  [FORM_FIELDS.FIRST_NAME]: validationSchema.firstName,
  [FORM_FIELDS.MIDDLE_NAME]: validationSchema.middleName,
  [FORM_FIELDS.LAST_NAME]: validationSchema.lastName,
  [FORM_FIELDS.PHONENUMBER]: validationSchema.phoneNumber,
  [FORM_FIELDS.ID_CARD]: Yup.string()
    .required('Vui lòng nhập số CCCD / Căn cước')
    .test(
      'len',
      'Số CCCD / Căn cước không hợp lệ',
      val =>
        val &&
        (val.length === 9 || val.length === 12) &&
        /^[a-zA-Z0-9]*$/.test(val),
    ),
  [FORM_FIELDS.FULL_NAME]: validationSchema.fullName,
  [FORM_FIELDS.BIRTHDAY]: Yup.string()
    .required()
    .test('isInvalid', 'Ngày tháng năm sinh chưa hợp lệ', val => {
      if (!val) {
        return false;
      }
      if (!moment(val).isValid()) {
        return false;
      }
      if (moment(val).isAfter(moment().subtract(BOD_RULES.MIN_AGE, 'y'))) {
        return false;
      }
      if (
        moment(val).isBefore(
          moment()
            .subtract(BOD_RULES.MAX_AGE, 'y')
            .subtract(BOD_RULES.MAX_AGE_APPEND_DAY + 1, 'd'),
        )
      ) {
        return false;
      }
      return true;
    }),
  [FORM_FIELDS.MONTHLY_INCOME]: validationSchema.monthlyIncome,
});

export const readyFormSubmit = (values, errors) =>
  keys(initialValue)
    .map(key => {
      if (key === FORM_FIELDS.MIDDLE_NAME)
        return !errors[FORM_FIELDS.MIDDLE_NAME];
      return !!values[key] && !errors[key];
    })
    .every(value => !!value);
